import React from "react";

const BgSVG = () => {
  return (
    <svg
      className="bg-img"
      viewBox="0 0 1920 336"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 150L23 155.933C46 161.705 92 173.571 137.6 171.967C183.4 170.364 228.6 155.291 274.4 165.233C320 175.174 366 209.809 411.6 217.024C457.4 224.24 502.6 204.036 548.4 188.483C594 172.929 640 162.347 685.6 173.571C731.4 184.795 776.6 217.826 822.4 223.278C868 228.569 914 206.121 960 208.847C1006 211.412 1052 239.312 1097.6 233.86C1143.4 228.569 1188.6 190.086 1234.4 172.128C1280 154.329 1326 156.895 1371.6 161.224C1417.4 165.553 1462.6 171.326 1508.4 180.145C1554 188.964 1600 200.829 1645.6 200.188C1691.4 199.707 1736.6 186.879 1782.4 183.191C1828 179.343 1874 184.795 1897 187.36L1920 190.086V336H1897C1874 336 1828 336 1782.4 336C1736.6 336 1691.4 336 1645.6 336C1600 336 1554 336 1508.4 336C1462.6 336 1417.4 336 1371.6 336C1326 336 1280 336 1234.4 336C1188.6 336 1143.4 336 1097.6 336C1052 336 1006 336 960 336C914 336 868 336 822.4 336C776.6 336 731.4 336 685.6 336C640 336 594 336 548.4 336C502.6 336 457.4 336 411.6 336C366 336 320 336 274.4 336C228.6 336 183.4 336 137.6 336C92 336 46 336 23 336H0V150Z"
        fill="#0066FF"
      />
      <path
        d="M136.103 73.256L134.466 35.775C134.406 34.45 133.042 33.3072 131.011 32.9428C126.828 32.1975 118.764 31.2038 106.761 31.651C97.8488 31.9822 92.4228 32.9263 89.4522 33.655C87.5728 34.1188 86.3906 35.2947 86.4513 36.57L88.0881 74.1006L136.103 73.256V73.256Z"
        fill="#356477"
      />
      <path
        d="M89.4522 33.655C92.4228 32.9263 97.8488 31.9988 106.761 31.651C118.764 31.2038 126.828 32.1975 131.011 32.9428C133.011 33.3072 134.406 34.45 134.466 35.775L134.891 45.4641C134.618 45.3978 134.375 45.2984 134.102 45.2488C129.525 44.5034 120.704 43.5263 107.518 44.0066C97.7275 44.3544 91.7862 45.2984 88.5125 46.0438C87.9062 46.1763 87.3909 46.3916 86.9059 46.64L86.4816 36.5534C86.4209 35.2947 87.5728 34.1022 89.4522 33.655V33.655Z"
        fill="#F44336"
      />
      <path
        d="M231.8 63.8153L229.92 19.8088C229.86 18.55 228.253 17.4735 225.919 17.1256C221.099 16.4135 211.733 15.4694 197.819 15.9C187.483 16.2147 181.208 17.1091 177.722 17.8047C175.54 18.2353 174.176 19.3616 174.236 20.5706L176.146 64.6269L231.8 63.8153Z"
        fill="#356477"
      />
      <path
        d="M177.722 17.8047C181.178 17.1091 187.452 16.2313 197.819 15.9C211.763 15.4694 221.099 16.4135 225.919 17.1256C228.253 17.4735 229.86 18.55 229.92 19.8088L230.405 29.001C230.102 28.9347 229.829 28.8353 229.466 28.8022C224.161 28.09 213.915 27.1625 198.638 27.6263C187.271 27.9575 180.39 28.8519 176.601 29.5475C175.903 29.68 175.297 29.8788 174.752 30.1106L174.236 20.5541C174.176 19.3616 175.54 18.2353 177.722 17.8047Z"
        fill="#F44336"
      />
      <path
        d="M127.282 44.4206C123.19 44.0563 117.855 43.8078 111.338 43.9238V31.5516C118.188 31.4853 123.493 31.8994 127.282 32.3797V44.4206Z"
        fill="#FF7555"
      />
      <path
        d="M221.19 27.9907C216.977 27.6925 211.642 27.4938 205.246 27.5269V15.8007C211.915 15.8172 217.25 16.1485 221.19 16.546V27.9907Z"
        fill="#FF7555"
      />
      <path
        d="M223.312 121.917L224.585 135.829L329.618 133.229L328.83 121.917C328.83 121.917 305.247 102.969 305.247 64.0141L206.549 60.801C206.549 60.801 201.851 66.2997 205.367 82.6469C211.248 110.356 223.312 121.917 223.312 121.917V121.917Z"
        fill="#EEEEEE"
      />
      <path
        d="M206.216 74.1338L305.944 75.4588C306.247 77.761 306.611 79.9804 307.035 82.1003L206.762 81.1563L206.216 74.1338Z"
        fill="#82AEC0"
      />
      <path
        d="M207.641 94.4891L310.673 94.6547C311.582 97.0231 312.552 99.2425 313.553 101.296H210.217L207.641 94.4891V94.4891Z"
        fill="#82AEC0"
      />
      <path
        d="M221.402 114.232L321.555 114.116C324.041 117.296 326.193 119.498 327.496 120.724L228.314 120.84C228.283 120.84 222.918 116.418 221.402 114.232Z"
        fill="#82AEC0"
      />
      <path
        d="M228.678 121.999L29.4335 134.67L26.0384 113.834L59.8066 111.515L53.6835 74.7631L206.155 61.1819C205.003 101.859 223.282 117.18 228.678 120.857V121.999V121.999Z"
        fill="#82AEC0"
      />
      <path
        d="M55.5325 85.7109L206.489 74.084C206.489 74.084 207.095 79.384 207.428 81.2059L56.6238 92.3359L55.5325 85.7109Z"
        fill="#365666"
      />
      <path
        d="M59.8369 111.515L58.7456 104.973L210.52 94.5056C211.339 96.8244 212.157 99.259 213.097 101.263L59.8369 111.515Z"
        fill="#365666"
      />
      <path
        d="M221.403 114.232C224.161 117.113 227.313 119.73 228.738 120.857L228.768 121.105L29.1909 133.063L28.13 126.455L221.403 114.232V114.232Z"
        fill="#365666"
      />
      <path
        d="M67.2331 91.5409L65.8388 84.9159L71.8406 84.4522L73.235 91.0937L86.2694 90.1331L84.8447 83.4418L90.8466 82.9781L92.2713 89.6859L105.306 88.7253L103.881 81.9843L109.883 81.5206L111.308 88.2781L124.342 87.3175L122.917 80.5103L128.919 80.0465L130.374 86.8703L143.408 85.9097L141.953 79.0528L147.955 78.589L149.41 85.479L162.445 84.5184L160.99 77.5953L166.992 77.1315L168.447 84.0712L181.481 83.1106L179.996 76.1212L185.998 75.6575L187.483 82.6634L207.641 81.1728C207.641 81.1728 207.883 82.6303 207.944 83.5247C208.004 84.419 208.247 86.1415 208.247 86.1415L57.4422 97.2053L56.6237 92.3028L67.2331 91.5409V91.5409Z"
        fill="#EEEEEE"
      />
      <path
        d="M54.32 78.44L206.61 65.7862L206.549 60.7844L53.4713 73.4381L54.32 78.44Z"
        fill="#EEEEEE"
      />
      <path
        d="M70.3553 110.803L69.0822 104.277L75.0841 103.863L76.3572 110.389L89.3916 109.511L88.1184 102.969L94.1203 102.555L95.3934 109.097L108.428 108.219L107.155 101.661L113.157 101.247L114.43 107.805L127.464 106.927L126.191 100.352L132.193 99.9381L133.466 106.513L146.5 105.636L145.227 99.0603L151.229 98.6463L152.502 105.238L165.537 104.36L164.263 97.7684L170.265 97.3544L171.538 103.946L184.573 103.068L183.3 96.46L189.423 96.0625L190.726 102.671L213.067 101.263C213.067 101.263 213.673 102.423 215.522 105.983L26.8569 118.803L26.0081 113.801L70.3553 110.803V110.803Z"
        fill="#EEEEEE"
      />
      <path
        d="M42.286 132.169L41.0129 125.643L47.0148 125.262L48.3182 131.804L62.3529 130.91L61.0798 124.368L67.0816 123.987L68.3851 130.529L82.4197 129.651L81.1163 123.109L87.1485 122.728L88.4519 129.27L102.487 128.392L101.183 121.834L107.215 121.453L108.519 128.012L122.553 127.134L121.25 120.558L127.282 120.177L128.586 126.753L142.62 125.875L141.317 119.3L147.349 118.919L148.653 125.494L162.687 124.6L161.384 118.024L167.416 117.643L168.719 124.235L182.754 123.341L181.451 116.749L187.483 116.368L188.786 122.96L202.821 122.082L201.518 115.49L207.55 115.093L208.853 121.701L228.799 120.84L230.769 137.055L31.5554 148.185L29.1607 133.013L42.286 132.169Z"
        fill="#EEEEEE"
      />
      <path
        d="M369.358 130.778C369.358 130.778 375.784 130.612 375.208 134.073C375.208 134.073 382.756 161.567 361.84 180.448C341.743 198.568 313.947 205.375 301.549 205.375H57.6544C42.4375 205.375 26.6447 199.114 21.1884 189.823C16.9144 182.519 13.1253 156.118 12.3372 148.069C12.2159 146.777 14.0044 145.667 16.3688 145.568C16.3688 145.568 237.256 130.595 369.358 130.778V130.778Z"
        fill="#356477"
      />
      <path
        d="M13.7012 158.901C13.7012 158.901 244.137 150.305 376.299 150.901L376.36 141.56C243.531 140.947 15.4594 154.528 13.1253 154.627L13.7012 158.901Z"
        fill="#F44336"
      />
      <path
        d="M329.254 129.734L329.467 131.109C219.523 132.848 77.0847 141.659 30.9794 144.624L30.4641 141.311C63.8685 139.175 147.683 134.107 232.952 130.778C265.75 129.502 329.254 129.734 329.254 129.734V129.734Z"
        fill="#82AEC0"
      />
      <path
        d="M1783.9 73.256L1785.53 35.775C1785.59 34.45 1786.96 33.3072 1788.99 32.9428C1793.17 32.1975 1801.24 31.2038 1813.24 31.651C1822.15 31.9822 1827.58 32.9263 1830.55 33.655C1832.43 34.1188 1833.61 35.2947 1833.55 36.57L1831.91 74.1006L1783.9 73.256V73.256Z"
        fill="#356477"
      />
      <path
        d="M1830.55 33.655C1827.58 32.9263 1822.15 31.9988 1813.24 31.651C1801.24 31.2038 1793.17 32.1975 1788.99 32.9428C1786.99 33.3072 1785.59 34.45 1785.53 35.775L1785.11 45.4641C1785.38 45.3978 1785.62 45.2984 1785.9 45.2488C1790.47 44.5034 1799.3 43.5263 1812.48 44.0066C1822.27 44.3544 1828.21 45.2984 1831.49 46.0438C1832.09 46.1763 1832.61 46.3916 1833.09 46.64L1833.52 36.5534C1833.58 35.2947 1832.43 34.1022 1830.55 33.655V33.655Z"
        fill="#F44336"
      />
      <path
        d="M1688.2 63.8153L1690.08 19.8088C1690.14 18.55 1691.75 17.4735 1694.08 17.1256C1698.9 16.4135 1708.27 15.4694 1722.18 15.9C1732.52 16.2147 1738.79 17.1091 1742.28 17.8047C1744.46 18.2353 1745.82 19.3616 1745.76 20.5706L1743.85 64.6269L1688.2 63.8153Z"
        fill="#356477"
      />
      <path
        d="M1742.28 17.8047C1738.82 17.1091 1732.55 16.2313 1722.18 15.9C1708.24 15.4694 1698.9 16.4135 1694.08 17.1256C1691.75 17.4735 1690.14 18.55 1690.08 19.8088L1689.59 29.001C1689.9 28.9347 1690.17 28.8353 1690.53 28.8022C1695.84 28.09 1706.08 27.1625 1721.36 27.6263C1732.73 27.9575 1739.61 28.8519 1743.4 29.5475C1744.1 29.68 1744.7 29.8788 1745.25 30.1106L1745.76 20.5541C1745.82 19.3616 1744.46 18.2353 1742.28 17.8047Z"
        fill="#F44336"
      />
      <path
        d="M1792.72 44.4206C1796.81 44.0563 1802.15 43.8078 1808.66 43.9238V31.5516C1801.81 31.4853 1796.51 31.8994 1792.72 32.3797V44.4206Z"
        fill="#FF7555"
      />
      <path
        d="M1698.81 27.9907C1703.02 27.6925 1708.36 27.4938 1714.75 27.5269V15.8007C1708.09 15.8172 1702.75 16.1485 1698.81 16.546V27.9907Z"
        fill="#FF7555"
      />
      <path
        d="M1696.69 121.917L1695.41 135.829L1590.38 133.229L1591.17 121.917C1591.17 121.917 1614.75 102.969 1614.75 64.0141L1713.45 60.801C1713.45 60.801 1718.15 66.2997 1714.63 82.6469C1708.75 110.356 1696.69 121.917 1696.69 121.917V121.917Z"
        fill="#EEEEEE"
      />
      <path
        d="M1713.78 74.1338L1614.06 75.4588C1613.75 77.761 1613.39 79.9804 1612.96 82.1003L1713.24 81.1563L1713.78 74.1338Z"
        fill="#82AEC0"
      />
      <path
        d="M1712.36 94.4891L1609.33 94.6547C1608.42 97.0231 1607.45 99.2425 1606.45 101.296H1709.78L1712.36 94.4891V94.4891Z"
        fill="#82AEC0"
      />
      <path
        d="M1698.6 114.232L1598.44 114.116C1595.96 117.296 1593.81 119.498 1592.5 120.724L1691.69 120.84C1691.72 120.84 1697.08 116.418 1698.6 114.232Z"
        fill="#82AEC0"
      />
      <path
        d="M1691.32 121.999L1890.57 134.67L1893.96 113.834L1860.19 111.515L1866.32 74.7631L1713.84 61.1819C1715 101.859 1696.72 117.18 1691.32 120.857V121.999V121.999Z"
        fill="#82AEC0"
      />
      <path
        d="M1864.47 85.7109L1713.51 74.084C1713.51 74.084 1712.9 79.384 1712.57 81.2059L1863.38 92.3359L1864.47 85.7109Z"
        fill="#365666"
      />
      <path
        d="M1860.16 111.515L1861.25 104.973L1709.48 94.5056C1708.66 96.8244 1707.84 99.259 1706.9 101.263L1860.16 111.515Z"
        fill="#365666"
      />
      <path
        d="M1698.6 114.232C1695.84 117.113 1692.69 119.73 1691.26 120.857L1691.23 121.105L1890.81 133.063L1891.87 126.455L1698.6 114.232V114.232Z"
        fill="#365666"
      />
      <path
        d="M1852.77 91.5409L1854.16 84.9159L1848.16 84.4522L1846.77 91.0937L1833.73 90.1331L1835.16 83.4418L1829.15 82.9781L1827.73 89.6859L1814.69 88.7253L1816.12 81.9843L1810.12 81.5206L1808.69 88.2781L1795.66 87.3175L1797.08 80.5103L1791.08 80.0465L1789.63 86.8703L1776.59 85.9097L1778.05 79.0528L1772.04 78.589L1770.59 85.479L1757.56 84.5184L1759.01 77.5953L1753.01 77.1315L1751.55 84.0712L1738.52 83.1106L1740 76.1212L1734 75.6575L1732.52 82.6634L1712.36 81.1728C1712.36 81.1728 1712.12 82.6303 1712.06 83.5247C1712 84.419 1711.75 86.1415 1711.75 86.1415L1862.56 97.2053L1863.38 92.3028L1852.77 91.5409V91.5409Z"
        fill="#EEEEEE"
      />
      <path
        d="M1865.68 78.44L1713.39 65.7862L1713.45 60.7844L1866.53 73.4381L1865.68 78.44Z"
        fill="#EEEEEE"
      />
      <path
        d="M1849.64 110.803L1850.92 104.277L1844.92 103.863L1843.64 110.389L1830.61 109.511L1831.88 102.969L1825.88 102.555L1824.61 109.097L1811.57 108.219L1812.85 101.661L1806.84 101.247L1805.57 107.805L1792.54 106.927L1793.81 100.352L1787.81 99.9381L1786.53 106.513L1773.5 105.636L1774.77 99.0603L1768.77 98.6463L1767.5 105.238L1754.46 104.36L1755.74 97.7684L1749.73 97.3544L1748.46 103.946L1735.43 103.068L1736.7 96.46L1730.58 96.0625L1729.27 102.671L1706.93 101.263C1706.93 101.263 1706.33 102.423 1704.48 105.983L1893.14 118.803L1893.99 113.801L1849.64 110.803V110.803Z"
        fill="#EEEEEE"
      />
      <path
        d="M1877.71 132.169L1878.99 125.643L1872.99 125.262L1871.68 131.804L1857.65 130.91L1858.92 124.368L1852.92 123.987L1851.61 130.529L1837.58 129.651L1838.88 123.109L1832.85 122.728L1831.55 129.27L1817.51 128.392L1818.82 121.834L1812.78 121.453L1811.48 128.012L1797.45 127.134L1798.75 120.558L1792.72 120.177L1791.41 126.753L1777.38 125.875L1778.68 119.3L1772.65 118.919L1771.35 125.494L1757.31 124.6L1758.62 118.024L1752.58 117.643L1751.28 124.235L1737.25 123.341L1738.55 116.749L1732.52 116.368L1731.21 122.96L1717.18 122.082L1718.48 115.49L1712.45 115.093L1711.15 121.701L1691.2 120.84L1689.23 137.055L1888.44 148.185L1890.84 133.013L1877.71 132.169Z"
        fill="#EEEEEE"
      />
      <path
        d="M1550.64 130.778C1550.64 130.778 1544.22 130.612 1544.79 134.073C1544.79 134.073 1537.24 161.567 1558.16 180.448C1578.26 198.568 1606.05 205.375 1618.45 205.375H1862.35C1877.56 205.375 1893.36 199.114 1898.81 189.823C1903.09 182.519 1906.87 156.118 1907.66 148.069C1907.78 146.777 1906 145.667 1903.63 145.568C1903.63 145.568 1682.74 130.595 1550.64 130.778V130.778Z"
        fill="#356477"
      />
      <path
        d="M1906.3 158.901C1906.3 158.901 1675.86 150.305 1543.7 150.901L1543.64 141.56C1676.47 140.947 1904.54 154.528 1906.87 154.627L1906.3 158.901Z"
        fill="#F44336"
      />
      <path
        d="M1590.75 129.734L1590.53 131.109C1700.48 132.848 1842.92 141.659 1889.02 144.624L1889.54 141.311C1856.13 139.175 1772.32 134.107 1687.05 130.778C1654.25 129.502 1590.75 129.734 1590.75 129.734V129.734Z"
        fill="#82AEC0"
      />
    </svg>
  );
};

export default BgSVG;
